/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        
        
      //Scrolling
      $(function() {
        $('.scroller').bind('click',function(event){
          var $anchor = $(this);
          $('html, body').stop().animate({
            scrollTop: $($anchor.attr('href')).offset().top
            }, 1500,'easeInOutExpo');
          event.preventDefault();
          });
        });
        
        //Fader Waypoint
        $('.promo-panel').addClass('fader');
        $('.fader_waypoint').waypoint(function(direction) {
            if (direction === 'down') {
              var gLoad = 0;     
              $('.fader').each(function() {
                  $(this).delay(gLoad).animate({opacity: 1.0, top: '0px'}, { duration: 400}); 
                  gLoad += 300;
              });
            } else {
              
            }
        },{ offset: '30%' });
        
        
       //Fader Left Waypoint
        $('.service-single').addClass('fader-left');
        $('.faderleft_waypoint').waypoint(function(direction) {
            if (direction === 'down') {     
              $('.fader-left').animate({opacity: 1.0, left: '0px'}, { duration: 400}); 
            } else {
              
            }
        },{ offset: '40%' });
        
        

        //Fixed carousel
          /*$('.product_waypoint').waypoint(function(direction) {
            if (direction === 'down') {
              $('#productsections').addClass('carfix');
            } else {
              $('#productsections').removeClass('carfix');
            }
        },{ offset: '8%' });*/

        
        //<![CDATA[
        $(window).load(function() {
          $('.home_banner_text').addClass('banner-fader');
          //$('.graph1').delay(1000).addClass('graph-fader');
          //$('.graph2').delay(2000).addClass('graph-fader');
          //$('.graph3').delay(3000).addClass('graph-fader');

          /*graph faders*/
           var gLoad = 0;     
              $('.graph-home').each(function() {
                  $(this).delay(gLoad).animate({opacity: 1.0, padding: '0px'}, { duration: 400}); 
                  gLoad += 300;
              });
        });
        //]]>

        
        $('.nav_waypoint').waypoint(function(direction) {
            if (direction === 'down') {
              $('.banner').addClass('navbg');
            } else {
              $('.banner').removeClass('navbg');
            }
        },{ offset: '-10%' });
        

        

        //Menu click
        $('.nav-icon').click(function() {
          var clicks = $(this).data('clicks');
          if (clicks) {
            //2
            $(this).toggleClass('cancel');
            $('.nav-mob').fadeToggle();
          } else {
            //1
            $(this).toggleClass('cancel');
            $('.nav-mob').fadeToggle();
          }
          $(this).data("clicks", !clicks);
        });

        //Banner scroll
        $(document).ready(function(){
        $(window).scroll(function(e){
          parallax();
        });
        function parallax(){
          var scrolled = $(window).scrollTop();
          $('.scroll_banner').css('top',(scrolled*0.5)+'px');
        }
        });


        // Slider      
        $(window).load(function() {
              // The slider being synced must be initialized first
              $('#carousel').flexslider({
              directionNav: false,
              animation: "slide",
              controlNav: false,
              animationLoop: false,
              slideshow: false,
              itemWidth: 210,
              itemMargin: 5,
              asNavFor: '.flexslider'
      });
              
              $('.flexslider').flexslider({
               slideshow: false,
               animation: "fade",
               easing: "swing",
               animationSpeed:	200,
               slideshowSpeed: 4000,
               controlNav: true,
               directionNav: true,
               smoothHeight: false,
               sync: "#carousel"
               });       
               
              
      });


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

        $(document).ready(function(){
        $(window).scroll(function(e){
          parallax();
        });
        function parallax(){
          var scrolled = $(window).scrollTop();
          $('.home_banner').css('top',(scrolled*0.5)+'px');
          //$('.home_banner').css('top',(scrolled*1.0)+'px');
        }
        });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
